import React, { PropTypes } from 'react';
import classNames from 'classnames';
import './OrderModalStep.less';

class OrderModalStep extends React.Component {
  constructor(props) {
    super(props);

    this.renderFooterContent = this.renderFooterContent.bind(this);
  }

  renderFooterContent() {
    const {footer, onBack, onPrimaryAction, primaryActionTitle, primaryActionEnabled} = this.props;

    return footer || (
      <div>
        {onBack ? (<button className="btn btn-link btn-back" onClick={onBack}>wróć</button>) : null}
        <button className="btn btn-primary btn-block" onClick={onPrimaryAction} disabled={!primaryActionEnabled}>{primaryActionTitle}</button>
      </div>
    );
  }

  render () {
    const {renderFooterContent} = this;
    const {className, title, children, onBack, onClose} = this.props;
    const rootClassName = classNames(className, 'order-modal-step');

    return (
      <section className={rootClassName}>
        <header className="modal-header">
          {onBack && <button className="btn btn-link btn-back" onClick={onBack}/>}
          <h1>{title}</h1>
          <small className="close-button" onClick={onClose}/>
        </header>
        <section className="modal-body">
          {children}
        </section>
        <footer className="modal-footer">
          {renderFooterContent()}
        </footer>
      </section>
    );
  }
}

OrderModalStep.defaultProps = {
  primaryActionEnabled: true
};

OrderModalStep.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  primaryActionTitle: PropTypes.string,
  primaryActionEnabled: PropTypes.bool,
  onPrimaryAction: PropTypes.func,
  onBack: PropTypes.func,
  onClose: PropTypes.func,
  children: PropTypes.node,
  footer: PropTypes.node
};

export default OrderModalStep;



// WEBPACK FOOTER //
// ./src/components/OrderModal/OrderModalStep/OrderModalStep.js